import React from 'react';
import { View } from 'react-native';
import { Text } from '@/components/Text';
import { Row } from './Row';
import { TextRow } from './TextRow';
import { styles } from './styles';
import { Button } from '@/components/ui/therapist/Button';

export function Selected({
  title,
  data,
  dataCount,
  onPress,
  headerPress,
  onButtonPress,
  isTextSet,
}) {
  return (
    <View style={styles.containerItem}>
      <View style={styles.containerItemHeader}>
        <View style={styles.containerItemHeaderText}>
          <Text style={styles.title}>{title || 'Selected'}</Text>
          <Text style={styles.titleSize}> {dataCount}</Text>
        </View>
        <Button onPress={headerPress} look="danger" icon="trash" />
      </View>
      <View style={styles.containerItemBody}>
        {data.map((eachData) => {
          if (isTextSet) {
            const { title, _id, simpleBody, textLength } = eachData;
            const isSelected = data.includes(_id);

            return (
              <React.Fragment key={_id + textLength}>
                <TextRow
                  isSelected={isSelected}
                  wholeObject={eachData}
                  bodyText={simpleBody}
                  hasTags
                  textLength={textLength}
                  title={title}
                  tags={[]}
                  onPress={onPress}
                  insideSelected
                />
                <View style={styles.seperator} />
              </React.Fragment>
            );
          } else {
            const { _id, pictures, print } = eachData;
            const hasImage = pictures.length > 0;
            const title = print;
            return (
              <React.Fragment key={_id}>
                <Row
                  wholeObject={eachData}
                  isTextSet={false}
                  hasImage={hasImage}
                  hasTags={false}
                  imageURL={pictures[0].appimage_url}
                  title={title}
                  insideSelected
                  tags={[]}
                  onPress={onPress}
                />
                <View style={styles.seperator} />
              </React.Fragment>
            );
          }
        })}
        {data.length > 0 ? (
          <Button
            style={{ margin: 10, alignSelf: 'flex-start' }}
            onPress={onButtonPress}
            label="Weiter"
          />
        ) : null}
      </View>
    </View>
  );
}
